import React from 'react';

/** @typedef {{
  id?: string,
  indicateOptional?: boolean,
  label: React.ReactNode,
  labelId?: string,
  className?: string,
  labelClassName?: string,
  htmlFor?: string
} & React.HTMLAttributes<HTMLDivElement> } VerticalFieldProps */

/** @type { React.SFC<VerticalFieldProps> } */
export const VerticalField = props => {
  const {
    label,
    indicateOptional = false,
    children,
    className = '',
    labelId,
    htmlFor,
    ...rest
  } = props;

  return (
    <div className={`text-left ${className}`} {...rest}>
      <label
        id={labelId}
        htmlFor={htmlFor}
        className="block text-gray-700 text-left font-bold mb-1"
        style={{ marginBottom: '0.25rem' }}
      >
        {label}
        {indicateOptional ? (
          <span className="font-normal ml-2 text-gray-500 text-xs">Optional</span>
        ) : null}
      </label>
      {children}
    </div>
  );
};
